import { render, staticRenderFns } from "./KualitasNyeri.vue?vue&type=template&id=4b2cde06&"
import script from "./KualitasNyeri.vue?vue&type=script&lang=ts&"
export * from "./KualitasNyeri.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
